<template>
  <div class="reports-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.reports'), disabled: true },
        { title: this.$t('reports.reports.titles.landing_page'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch"/>
        <va-popover
          class="mr-2"
          v-if="canUpdateReports"
          placement="left"
          :message="$t('reports.reports.buttons.bulk_lock_update')">
          <span class="fa fa-lock clickable" style="font-size: 1.65rem;"
                @click.prevent="isBulkLocking = !isBulkLocking"></span>
        </va-popover>
        &ensp;
        <va-popover
          class="mr-2"
          v-if="canUpdateReports"
          placement="left"
          :message="$t('reports.reports.buttons.bulk_update')">
          <span class="fa fa-upload clickable" style="font-size: 1.65rem;"
                @click.prevent="isBulkUploading = !isBulkUploading"></span>
        </va-popover>
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters"
        />
      </div>
    </Breadcrumbs>
    <ReportsTable
      ref="reportsTable"
      :serviceUrl="component.service.url"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @filters-updated="onFiltersUpdated"
      @loaded="onLoaded"
    />

    <BulkUpload
      v-if="isBulkUploading"
      :serviceUrl="component.service.url"
      @bulkUpload="onBulkUploadSuccessful"
      @modalWasClosed="onBulkUploadModalWasClosed"
    >
    </BulkUpload>

    <BulkLock
      v-if="isBulkLocking"
      :serviceUrl="component.service.url"
      :params="getRequestParams()"
      :count="totalResults"
      @bulkLock="onBulkLockSuccessful"
      @modalWasClosed="onBulkLockModalWasClosed"
    >
    </BulkLock>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_REPORTS } from '@/local-storage/LocalStorageKeys'
import ReportsTable from '@/components/reports/reports/ReportsTable'
import Filters from '@/components/common/Filters'
import BulkUpload from '@/components/reports/reports/BulkUpload'
import BulkLock from '@/components/reports/reports/BulkLock'

const reportsInfoType = 210
export default {
  components: {
    BulkLock,
    BulkUpload,
    Filters,
    ReportsTable,
    Searchable,
    Breadcrumbs
  },
  mixins: [
    IndexTablesMixin
  ],
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      totalResults: 0,
      isBulkUploading: false,
      isBulkLocking: false,
      showFilters: true,
      activeFilters: 0,
      querySearch: '',
      customQueries: {},
      localStorageKey: TABLE_REPORTS
    }
  },
  computed: {
    reportsService: function () {
      return this.$store.state.services.find(service => service.url === this.component.service.url)
    },
    canUpdateReports: function () {
      return this.writableReportsEntities.length > 0
    },
    writableReportsEntities: function () {
      if (this.reportsService) {
        let writableReportPermissions = this.reportsService.user_permissions.filter(permission => permission.access_type >= 2 && permission.info_type === reportsInfoType)

        if (writableReportPermissions.length > 0) {
          let writableEntities = []

          if (writableReportPermissions[0].entity_id === null) {
            writableEntities = this.reportsService.entities
          } else {
            writableReportPermissions.forEach(permission => {
              writableEntities.push(this.reportsService.entities.find(entity => entity.id === permission.entity_id))
            })
          }
          return writableEntities
        }
      }
      return []
    },
  },
  methods: {
    onLoaded: function (data) {
      this.totalResults = data.count
    },
    getRequestParams: function () {
      let customQueries = this.$refs.reportsTable.customQueries
      let query = this.$refs.reportsTable.query
      let params = {}

      Object.keys(customQueries).forEach(key => {
        if (customQueries[key]) {
          params[key] = customQueries[key]
        }
      })

      if (params.hasOwnProperty('clients')) {
        params.clients = params.clients.split(',')
      }

      if (query) {
        params.query = this.$refs.reportsTable.query
      }

      // console.log(params)
      return params
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onBulkUploadModalWasClosed: function () {
      this.isBulkUploading = false
    },
    onBulkUploadSuccessful: function (data) {
      let index = this.$refs.reportsTable.data.findIndex(element => element.id === data.id)
      this.$refs.reportsTable.data[index] = data
      this.$refs.reportsTable.refresh()
      // this.$refs.reportsTable.reload()
      this.isBulkUploading = false
    },
    onBulkLockSuccessful: function () {
      this.$refs.reportsTable.reload()
      this.isBulkLocking = false
    },
    onBulkLockModalWasClosed: function () {
      this.isBulkLocking = false
    },
  }
}
</script>

<style lang="scss">

</style>
